import { PricingEnum, BodyTypeEnum } from './constants';

export function setupTrackers() {
  let localStorageTracker = localStorage.getItem('audiModelTracker');

  if (localStorageTracker) {
    const parsed = JSON.parse(localStorageTracker);
    localStorageTracker = parsed;
  } else {
    localStorageTracker = {
      updatedPriceTracker: {
        [PricingEnum.ENTRY]: 0,
        [PricingEnum.MID]: 0,
        [PricingEnum.PREMIUM]: 0,
        [PricingEnum.LUXURY]: 0,
        [PricingEnum.SPORT]: 0,
      },
      updatedBodyTypeTracker: {
        [BodyTypeEnum.SEDAN]: 0,
        [BodyTypeEnum.COUPE]: 0,
        // [BodyTypeEnum.CONVERTIBLE]: 0,
        [BodyTypeEnum.WAGON]: 0,
        [BodyTypeEnum.SPORTBACK]: 0,
        [BodyTypeEnum.SUV]: 0,
        [BodyTypeEnum.ELECTRIC]: 0,
        [BodyTypeEnum.SPORT]: 0,
      },
      lastSavedBuildUrl: null,
    };
  }

  return localStorageTracker;
}
